import {Component, OnInit} from '@angular/core';
import {BonusService} from './bonus.service';
import {AppService} from '../../app.service';
import {Permission} from '../../models/permission.model';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'fx-bonus',
  templateUrl: './bonus.component.html',
  styleUrls: ['./bonus.component.sass']
})
export class BonusComponent implements OnInit {
  permission: Permission;
  proEnvi = (environment.name === 'pro');
  onLoadCodeData = '';
  tabs = [
    {
      label: 'Permanent Bonus'
    }
  ];
  tabSelect: any;
  constructor(
    private bonusService: BonusService,
    private appService: AppService
  ) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }

  ngOnInit(): void {
    this.tabSelect = this.tabs[0]
  }

  onLoadCodeHistory(event): void {
    this.onLoadCodeData = event;
  }
  onChangeTab(event): void {
    this.tabSelect = event;
  }
}
